import fetchAPI from '../utils/fetchAPI';

const getPosts = async (settings, args, page = 1) => {
	let url = `${settings.apiBase}/get-posts?post_type=${settings.postType}&posts_per_page=${settings.postsPerPage}&paged=${page}`;
	Object.entries(args.selectedTax).forEach(([tax, term]) => {
		url += `&tax[${tax}]=${term}`;
	});

	if (args.searchQuery) {
		url += `&s=${args.searchQuery}`;
	}

	if (settings.initSelectedAuthor) {
		url += `&author=${settings.initSelectedAuthor}`;
	}

	return await fetchAPI(url);
};

export default getPosts;
